import React, { PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../auth';

/**
 * Basic component that requires the user to be authenticated. If they are not
 * authenticated, they will be redirected to the login page.
 */
function RequireAuth({ children }: PropsWithChildren) {
  const { userContext } = useAuth();
  const location = useLocation();

  // If the user is not authenticated, redirect them to the login page.
  if (!userContext) {
    // Redirect them to the "login" page "/", but save the current location they were
    // trying to go to when they were redirected.
    return <Navigate to={`/${location.search}`} state={{ from: `${location.pathname}${location.search}` }} replace />;
  }

  if (!userContext.user?.contractor) {// if the user doesn't have a contractor
    if (!userContext.user?.admin) {
      return <Navigate to={`/${location.search}`} state={{ from: `${location.pathname}${location.search}` }} />;
    }
  }

  return children;
}

export default RequireAuth;
